import React from "react";
import { RoutePermittedRole } from "shared/constants/AppConst";

export const DonationPurposeConfig = [
  {
    permittedRole: RoutePermittedRole.User,
    path: "/donation-purpose",
    component: React.lazy(() => import("./donation-detail")),
  },
];
